import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AdminModule} from './app/admin.module';
import {environment} from './environments/environment';


if (environment.production) {
  enableProdMode();
}

const widgetScript = document.createElement('script');
widgetScript.src = environment.widgetUrl;
widgetScript.async = true;
document.head.appendChild(widgetScript);

platformBrowserDynamic().bootstrapModule(AdminModule)
  .catch(err => console.error(err));
